'use client'

import { useReassuranceCards } from '@/feature/cms/hooks/useReassuranceCards'
import { Footer } from '@/feature/footer/components/footer/Footer'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { logErrorToNewRelic } from '@/lib/newrelic/logErrorToNewRelic'
import { Picture } from '@/ui/media/picture/Picture.client'
import { Media } from '@gql-generated/graphql'
import { useFaqConfigContext } from 'app/(web)/(account)/(authentication)/_components/FaqConfigContext'
import { useEffect } from 'react'
import { ErrorPageHero } from '../../components/error-page-hero/ErrorPageHero.client'
import { RevealError } from '../../components/reveal-error/RevealError.client'

/**
 * @design https://www.figma.com/design/taZo3cSvulzI4N9o8xLrxB/08.CGV-CGU-404-500-Contact?node-id=403-33106
 */
export function InternalServerErrorPage({ error, isGlobal }: { error: Error; isGlobal?: boolean }) {
  const { t } = useTranslation(['InternalServerErrorPage'])

  const { enableFaq } = useFaqConfigContext()
  const reassuranceCards = useReassuranceCards({ skip: !isGlobal })

  useEffect(() => {
    logErrorToNewRelic(error)
  }, [error])

  return (
    <ErrorPageHero
      skin="body-alt"
      title={t('InternalServerErrorPage:title')}
      paragraphs={[
        t('InternalServerErrorPage:description.line1'),
        t('InternalServerErrorPage:description.line2'),
      ]}
      image={
        <Picture
          image={{ set: [{ media: Media.Mobile, url: '/media/image/error-500.svg' }], alt: '' }}
          isDecorative
          width="280"
          height="280"
        />
      }
      infosOutlet={<RevealError error={error} />}
      {...(isGlobal && {
        footerOutlet: <Footer isFaqEnabled={enableFaq} reassuranceCards={reassuranceCards} />,
      })}
    />
  )
}
